<div *nzModalTitle class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
    <div style="display: flex; align-items: center;">
        <p class="modal-title">{{data.nzTitle}}</p>
    </div>

    <div class="flex justify-end">
        <button (click)="addRow()" class="button primary-button"
        [disabled]="fieldsReadOnly">
            Añadir producto final
        </button>
    </div>
</div>

<div #modalContent class="w-full h-full p-0 m-0 overflow-auto">
    @if (isLoading) {
	    <app-loader></app-loader>
	}
	@else{
        @for (articleSelected of articlesSelected; track idx; let idx = $index) {
        <div class="px-4 w-full">
            @if (idx !== 0) {
            <div class="px-10">
                <nz-divider></nz-divider>
            </div>
            }

            <div nz-row [nzGutter]="8" nzAlign="middle" class="py-4">
                <div nz-col nzXs="24" nzSm="12" nzMd="16">
                    <div nz-row [nzGutter]="8" nzAlign="middle">
                        <div nz-col nzXs="6" nzSm="6" nzMd="6">
                            <nz-select class="w-full" nzShowSearch nzPlaceHolder="Seleccione un artículo a producir"
                                [(ngModel)]="articlesSelected[idx]"
                                (ngModelChange)="updateArticleRelatedFields($event, articleSelected)"
                                [name]="'articleSelector' + idx" [compareWith]="compareById"
                                [nzDisabled]="fieldsReadOnly">
                                @for (
                                article of articles;
                                track subidx;
                                let subidx = $index
                                ) {
                                <nz-option [nzLabel]="article.name" [nzValue]="article"
                                    [nzDisabled]="isDisabled(article.id)"></nz-option>
                                }
                            </nz-select>
                        </div>
                        @if (articlesSelected[idx].useBatches) {
                        <div nz-col nzXs="6" nzSm="6" nzMd="6">
                            <nz-input-group [nzPrefix]="searchIcon" [nzSuffix]="inputClearTpl">
                                <input onfocus="select()" placeholder="Busca un lote" nz-input [(ngModel)]="searchBatch[idx]"
                                    (ngModelChange)="onSearchBatch($event, articlesSelected[idx].id)" />
                            </nz-input-group>
                            <ng-template #inputClearTpl>
                                @if (searchBatch[idx]) {
                                <span class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle"
                                    (click)="clearFilterBatch(idx, articlesSelected[idx].id)" nz-icon></span>
                                }
                            </ng-template>
                            <ng-template #searchIcon>
                                <span nz-icon nzType="search"></span>
                            </ng-template>
                        </div>
                        <div nz-col nzXs="6" nzSm="6" nzMd="6">
                            <label nz-checkbox [ngModel]="showOnlySelectedBatches[articlesSelected[idx].id]"
                                (ngModelChange)="showOnlySelectedBatches[articlesSelected[idx].id] = !showOnlySelectedBatches[articlesSelected[idx].id]">
                                Mostrar solo lotes seleccionados
                            </label>
                        </div>
                        }
                    </div>

                </div>

                <div nz-col nzXs="24" nzSm="12" nzMd="8">
                    <div nz-row [nzGutter]="8" nzJustify="end" nzAlign="middle">
                        @if (articlesSelected[idx].useBatches) {
                        <div nz-col>
                            <button class="button terciary-button" (click)="onGenerateNewBatch(idx)" [disabled]="fieldsReadOnly">
                                Generar un nuevo lote
                            </button>
                        </div>
                        }

                        <div nz-col>
                            <button class="button neutral-outlined-button" (click)="removeSelectedArticle(idx)" [disabled]="fieldsReadOnly">
                                Eliminar
                            </button>
                        </div>

                    </div>
                </div>
            </div>
            @if (articlesSelected[idx] && articlesSelected[idx].useBatches) {
            <nz-table [nzData]="showOnlySelectedBatches[articlesSelected[idx].id] ? selectedBatchesByArticleId[articlesSelected[idx].id] : batchesOfArticlesSelected[articlesSelected[idx].id]"
                [nzFrontPagination]="false"
                [nzShowPagination]="false">
                <thead>
                    <tr>
                        <th>Selec.</th>
                        <th>Lote</th>
                        <th>Cantidad a producir</th>
                        <th>Cantidad actual</th>
                        <th>Cantidad total prevista</th>
                        <th>Formatos</th>
                    </tr>
                </thead>
                <tbody>
                    @for (
                    batch of showOnlySelectedBatches[articlesSelected[idx].id] ?
                    selectedBatchesByArticleId[articlesSelected[idx].id] :
                    batchesOfArticlesSelected[articlesSelected[idx].id];
                    track subidx;
                    let subidx = $index
                    ) {
                    <tr>
                        <td>
                            <label class="ml-5" nz-checkbox [ngModel]="isBatchSelected(articlesSelected[idx].id, batch.id!)"
                                (nzCheckedChange)="setAsSelected(articlesSelected[idx].id, subidx)" [disabled]="fieldsReadOnly"></label>
                        </td>
                        <td>{{ batch.batchNumber }}</td>
                        <td>
                            <nz-input-group [nzSuffix]="articlesSelected[idx].measurementUnit.abbreviation">
                                <input onfocus="select()" nz-input type="number"
                                [ngModel]="getQuantityToProduce(articlesSelected[idx].id, batch.id!)"
                                (ngModelChange)="setQuantityToProduce(articlesSelected[idx].id, batch, $event)"
                                [disabled]="fieldsReadOnly"/>
                            </nz-input-group>
                        </td>
                        <td>{{ batch.quantity }} {{ articlesSelected[idx].measurementUnit.abbreviation }}</td>
                        <td>
                            {{ batch.quantity + getQuantityToProduce(articlesSelected[idx].id, batch.id!) }} {{ articlesSelected[idx].measurementUnit.abbreviation }}
                        </td>
                        <td class="flex gap-2 items-center">
                            <button type="button" (click)="onAddPackagings(undefined, batch, idx, subidx)"
                                [disabled]="!batch.article?.usePackagings || fieldsReadOnly" class="p-2">
                                <img src="assets/icons/plus-icon.svg" alt="Añadir formatos" class="h-6 w-6"
                                    title="Añadir formatos" />
                            </button>
                            @if(batch.packagings?.length){
                                <div>
                                    ({{batch.packagings?.length || 0}})
                                </div>
                            }
                        </td>
                    </tr>
                    }
                </tbody>
            </nz-table>
            } @else if(articlesSelected[idx].id && !articlesSelected[idx].useBatches){
            <nz-table [nzData]="[articlesSelected[idx]]" class="m-0 p-0" nzSize="small" nzTableLayout="auto"
                [nzBordered]="true" [nzScroll]="{ y: '350px' }" [nzFrontPagination]="false"
                [nzShowPagination]="false">
                <thead>
                    <tr>
                        <th>Cantidad a producir</th>
                        <th>Cantidad actual</th>
                        <th>Cantidad total prevista</th>
                        <th>Formato</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <nz-input-group [nzSuffix]="articlesSelected[idx].measurementUnit.abbreviation">
                                <input onfocus="select()" nz-input type="number"
                                [(ngModel)]="quantitiesToProduce[articlesSelected[idx].id][0].quantity"
                                (ngModelChange)="clearPackagings(articlesSelected[idx])" [disabled]="fieldsReadOnly"/>
                            </nz-input-group>
                        </td>
                        <td>{{ articlesSelected[idx].quantity }} {{ articlesSelected[idx].measurementUnit.abbreviation }}</td>
                        <td>
                            {{ articlesSelected[idx].quantity + quantitiesToProduce[articlesSelected[idx].id][0].quantity}} {{ articlesSelected[idx].measurementUnit.abbreviation }}
                        </td>
                        <td class="flex gap-2 items-center">
                            <button type="button" (click)="onAddPackagings(articlesSelected[idx], undefined, idx)"
                                [disabled]="!articlesSelected[idx].usePackagings || fieldsReadOnly" class="p-2">
                                <img src="assets/icons/plus-icon.svg" alt="Añadir formatos" class="h-6 w-6"
                                    title="Añadir formatos" />
                            </button>
                            @if(articlesSelected[idx].packagings?.length){
                                <div>
                                    ({{articlesSelected[idx].packagings?.length || 0}})
                                </div>
                            }
                        </td>
                    </tr>
                </tbody>
            </nz-table>
            }
        </div>
        }
    }
</div>

<div *nzModalFooter>
    <div class="flex justify-end">
        <button (click)="handleCancel()" class="button secondary-button mr-2">
            Cancelar
        </button>

        @if(!fieldsReadOnly){
            <button nz-button class="button primary-button" (click)="save()" [nzLoading]="isSaving">
                Aceptar
            </button>
        }
    </div>
</div>
